import { createRoute, useNavigate } from '@tanstack/react-router';
import { PantallaIngreso } from '../funcionalidades/autenticacion/pantalla-ingreso.js';
import { rutaRaiz } from './raiz.js';

/**
 * Ruta pública. NO lleva guardián a propósito: es la única puerta de entrada, y ponerle
 * uno produciría una redirección en círculo para quien no tiene sesión.
 *
 * La navegación vive acá y no en `PantallaIngreso`, que solo avisa a dónde hay que ir.
 * Así la prueba de las cuatro filas del esquema de escenario no tiene que montar un
 * router entero para verificar que a cada rol le toca su vista.
 */
export const rutaIngresar = createRoute({
  getParentRoute: () => rutaRaiz,
  path: '/ingresar',
  validateSearch: (busqueda: Record<string, unknown>) => ({
    motivo: typeof busqueda.motivo === 'string' ? busqueda.motivo : undefined,
  }),
  component: function RutaIngresar() {
    const navigate = useNavigate();
    return (
      <PantallaIngreso
        alEntrar={(_sesion, destino) => {
          void navigate({ to: destino, replace: true });
        }}
      />
    );
  },
});
